import axios from "axios";
import store from "@/store";
import router from "@/router";
import Qs from "qs";
import {Dialog,Toast} from "vant";
import utils from 'libs/utils'

const loading='';
class HttpRequest {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
        this.queue = {};
    }
    getInsideConfig(method) {
        var token = localStorage.getItem('token');
        var urid = localStorage.getItem('urid');
        const config = {
            baseURL: this.baseUrl,
            params: {
                token
            },
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                'access-token': token,
            },
            timeout: 10e3,
            transformRequest: [
                function (data) {
                    console.log(data,method)
                    if (!data) data = {};
                    var userinfo = store.getters.getUserInfo;
                    if (userinfo) {
                        let {urid, token} = userinfo;
                        Object.assign(data, {urid, token});
                    } else {
                        Object.assign(data);
                    }
                    if (method === "post" || method === "put") {
                        return Qs.stringify(data);
                    } else {
                        return data;
                    }
                }
            ]
        };
        return config;
    }

    destroy(url) {
        delete this.queue[url];
    }
     startLoading() {
        this.loading = Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: '拼命加载中...',
            background:'rgba(255,255,255,0.5)',
        });
    }
    endLoading() {
       this.loading.close()
    }
    interceptors(instance, url) {
        // 请求拦截
        instance.interceptors.request.use(
            config => {
                // 添加全局的loading...
                this.startLoading()
                if (!Object.keys(this.queue).length) {
                  // Spin.show() // 不建议开启，因为界面不友好
                }
                // console.log(config,'11')
                if (config.method === "get") {
                  var params = Object.assign(config.params, config.data);
                  config.params = params;
                }
                this.queue[url] = true;
                return config;
            },
            error => {
                return Promise.reject(error);
            }
        );
        // 响应拦截
        instance.interceptors.response.use(
            res => {
                this.destroy(url);
                const {data} = res;
                let reqdata = Qs.parse(res.config.data);
                this.endLoading()
                //不需要异常提示
                if(reqdata.api_throw_exception === 'false')  return Promise.resolve(data);
                if (data.status == 200 || data.statusCode == 200||data.code == 200) {
                    //!!TODO move 定制
                } else if (data.status == 201||data.code == 401 || data.message == "urid上传错误") {
                    Dialog.confirm({
                        title: "提示",
                        message: "当前操作需要登录,立即登录?"
                    }).then(() => {
                        //同时登陆
                        utils.setLastRouter(router.currentRoute)
                        store.commit("clearUserInfo");
                        router.replace({name: "login"});
                    });
                } else {
                    Dialog.alert({
                        title: "提示",
                        message: data.message
                    })
                }

                return Promise.resolve(data);
            },
            error => {
                let message = error.message;
                if (error.message.indexOf("timeout of") !== -1) {
                    message = "请求超时，请刷新页面再试";
                }
                Dialog.alert({
                    title: "提示",
                    message: message
                });
                this.destroy(url);
                return Promise.reject(error);
            }
        );
    }

    request(options) {
        if(typeof options.method == 'undefined')
            options.method = 'get';
        var method = options.method.toLowerCase();
        const instance = axios.create();
        options = Object.assign(this.getInsideConfig(method), options);
        this.interceptors(instance, options.url);
        return instance(options);
    }
}

export default HttpRequest;
